import { Enrollment, EnrollmentDto } from './Enrollment';
import { utilities } from 'utils/utilities';

export interface EventEnrollmentDto extends EnrollmentDto {
  eventName: string;
  metadataJson?: string;
}

export class EventEnrollment extends Enrollment {
  eventName: string;
  metadataJson?: string;
  readonly type: 'EventEnrollment' = 'EventEnrollment';

  constructor(id: string, eventName: string, metadataJson?: string) {
    super(id);
    this.eventName = eventName;
    this.metadataJson = metadataJson;
  }

  toDto(): EventEnrollmentDto {
    return {
      eventName: this.eventName,
      metadataJson: this.metadataJson,
      id: this.id,
      enrollmentType: this.type,
      dtoType: 'Models.Api.Dtos.EventEnrollmentDto',
      nodeInstanceId: this.nodeInstanceId,
      requiredSubmissionType: this.requiredSubmissionType,
      status: this.status,
      satisfiedAt: this.satisfiedAt,
    };
  }

  static fromDto(dto?: Partial<EventEnrollmentDto> | EventEnrollment | any): EventEnrollment {
    if (!dto) {
      return new EventEnrollment(utilities.DEFAULT_GUID, '');
    }

    if (dto instanceof EventEnrollment) {
      return dto;
    }

    const id = dto.id ?? utilities.DEFAULT_GUID;
    const eventName = dto.eventName ?? '';
    return new EventEnrollment(id, eventName, dto.metadataJson);
  }
}

// Self-register to avoid Enrollment needing a hard import
Enrollment.register('EventEnrollment', (d?: any) => EventEnrollment.fromDto(d));
